export default () => localStorage.getItem("impersonate") === "true";
